<template>
    <b-card no-body>
        <div class="card-header pb-1">
            <b-card-title>
                {{ $t('Component(Text):general-info') }}
            </b-card-title>
        </div>
        <div class="p-2">
            <validation-observer ref="generalInfo">
                <b-form-group
                    :label="$t('Component(Label):name')"
                    label-for="name"
                >
                    <validation-provider
                        #default="{ errors }"
                        :name="$t('Component(Label):name')"
                        rules="required"
                    >
                        <b-form-input
                            :state="errors.length > 0 ? false:null"
                            id="name"
                            v-model="title"
                            @change="emit"
                            :placeholder="$t('Component(Placeholder):name')"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>

                <b-form-group
                    :label="$t('Component(Label):description')"
                    label-for="description"
                >
                    <b-form-textarea
                        id="description"
                        v-model="description"
                        @change="emit"
                        :placeholder="$t('Component(Placeholder):description')"
                    />
                </b-form-group>

                <b-form-group
                    :label="$t('Component(Label):comment')"
                    label-for="comment"
                >
                    <b-form-textarea
                        id="comment"
                        v-model="comment"
                        @change="emit"
                        :placeholder="$t('Component(Placeholder):comment')"
                    />
                </b-form-group>
            </validation-observer>
        </div>
    </b-card>
</template>

<script>
import backendResponse from "@core/mixins/ui/backend-response";
import AddEditOrganization from "@/views/administration/organization/AddEditOrganization";
import Actions from "@/views/administration/subscriber/components/Actions";
import {required} from '@validations'
import {BOverlay, BCard, BCardTitle, BFormGroup, BFormInput, BFormTextarea, BFormCheckbox,
    BFormDatepicker} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'

export default {
    mixins: [backendResponse],
    components: {
        BOverlay, BCard, BCardTitle, BFormGroup, BFormInput, BFormTextarea, BFormCheckbox,
        AddEditOrganization, Actions, ValidationProvider, ValidationObserver, BFormDatepicker,
    },
    props: {
        generalInfo: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            title: null,
            description: null,
            comment: null,
            required,
        };
    },
    methods: {
        emit() {
            this.$emit('input', {
                title: this.title,
                description: this.description,
                comment: this.comment,
            });
        },
        validate() {
            return this.$refs.generalInfo.validate();
        }
    },
    watch: {
        generalInfo(v) {
            this.title = v.title;
            this.description = v.description;
            this.comment = v.comment;
        }
    }
}
</script>

<style scoped>

</style>
